import { useLayoutEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AnnouncementBanner from '../components/AnnouncementBanner';

/**
 * Layout di lingua: sincronizza i18next e <html lang> con la route.
 *
 * Niente reindirizzamento automatico sulla lingua del browser (rimosso il
 * 16/09/2026). Mandava chi ha il browser non italiano da "/" a "/en" via
 * navigate(), ma i meta non seguivano il cambio rotta: il canonical continuava
 * a dichiarare "https://aitrack.it/" mentre l'indirizzo era ormai "/en", cioe'
 * puntava a un bersaglio hreflang diverso. PageSpeed misura sempre con browser
 * inglese e archiviazione vuota, quindi lo incontrava a ogni esecuzione e la
 * SEO si fermava a 85 ("Points to another hreflang location").
 *
 * Google sconsiglia comunque il reindirizzamento automatico per lingua, perche'
 * impedisce a utenti e crawler di raggiungere tutte le versioni: la scelta
 * resta all'utente tramite il selettore, con hreflang it/en/x-default a
 * dichiarare le versioni disponibili.
 *
 * Insieme al salto e' sparita anche la scrittura di localStorage
 * "preferred_lang": la leggeva soltanto quel controllo, nessun altro punto del
 * sito la consultava.
 */
export default function LanguageLayout({ lang }) {
  const { i18n } = useTranslation();

  useLayoutEffect(() => {
    if (i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }
    if (typeof document !== 'undefined') {
      document.documentElement.lang = lang;
    }
  }, [lang, i18n]);

  return (
    <>
      <AnnouncementBanner />
      <Outlet />
    </>
  );
}
